import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes, OctetString } from "@peculiar/asn1-schema";
export class ResponseBytes {
    constructor(params = {}) {
        this.responseType = "";
        this.response = new OctetString();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], ResponseBytes.prototype, "responseType", void 0);
__decorate([
    AsnProp({ type: OctetString })
], ResponseBytes.prototype, "response", void 0);
